import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { EventSurveyQuestionTypesEnum, EventSurveyTargetEnum, EventSurveyTypesEnum, IntegrationTypeEnum, RoutesEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import EventSurveyForm from "~/forms/EventSurveyForm";
import eventSurveySchema from "~/forms/EventSurveyForm/eventSurveySchema";
import eventSurveysActionCreators from "~/store/eventSurveys/actions";
import eventSurveySelectors from "~/store/eventSurveys/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import { Alert } from "~/components-shared";
import integrationSelectors from "~/store/integrations/selectors";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const EventSurveyCreateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(eventSurveySelectors.getAction);
  const status = useSelector(eventSurveySelectors.getStatusByEventSurvey("+"));
  const error = useSelector(eventSurveySelectors.getErrorByEventSurvey("+"));
  const slackIntegration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.SLACK));
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultValues = {
    type: EventSurveyTypesEnum.FEEDBACK_CARD,
    target: slackIntegration ? EventSurveyTargetEnum.SLACK : EventSurveyTargetEnum.EMAIL,
    eventId: "",
    questions: [{
      text: "",
      type: EventSurveyQuestionTypesEnum.EVALUATION
    }],
    scheduledAt: ""
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm({
    resolver: yupResolver(eventSurveySchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action, slackIntegration]);
  const onSubmit = handleSubmit(data => {
    dispatch(eventSurveysActionCreators.createStarted(data, _ref => {
      let {
        data: newEventSurvey
      } = _ref;
      if (newEventSurvey) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("EventSurveyCreate.eventSurveyCreated", {
            name: newEventSurvey.event.name
          }),
          timeout: 10000,
          actions: [{
            icon: "external-link",
            onClick: () => history.push(RoutesEnum.EVENT_SURVEY.replace(":eventSurveyId", newEventSurvey.id))
          }]
        }));
        reset(defaultValues);
      }
    }));
  });
  const onCancel = () => {
    dispatch(eventSurveysActionCreators.actionChanged(undefined, undefined));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("EventSurveyCreate.createEventSurvey"),
    onClose: onCancel,
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(EventSurveyForm, {
    control: control,
    setValue: setValue
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("EventSurveyCreate.saveEventSurvey")))));
};
export default EventSurveyCreateModal;